import { Component, OnInit, Inject, ViewChildren, ViewChild, AfterViewInit, HostListener, EventEmitter, Output, ElementRef, AfterViewChecked } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl, NgModel } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserDetailModel, UpdateUserModel, ExistUserCheckModel } from 'src/app/viewModels/users/UserListModel';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { UserService } from '../services/user/user.service';
import { RoleService } from '../../roless/services/role.service';


@Component({
  selector: 'app-create-users',
  templateUrl: './create-users.component.html',
  styleUrls: ['./create-users.component.scss']
})
export class CreateUsersComponent implements OnInit, AfterViewChecked {
  @ViewChild('email', {static: true}) email:ElementRef;
  @ViewChild('firstname', {static: true}) firstname:ElementRef;

  userDetailform: FormGroup;
  userDetail: UserDetailModel = new UserDetailModel();
  updateUserDetail: UpdateUserModel = new UpdateUserModel();
  existingUser: ExistUserCheckModel = new ExistUserCheckModel();
  titleAlert = 'This field is required';
  isEdit: boolean;
  hide = true;
  selectedroles: any[];
  roles: any[];
  UserRoles: any[];
  phoneNumberExt: string;
  dialogTitle: string;
  createUserResponseHolder: any;
  isActiveChecked : boolean = true;
  closePannel:boolean = false;
  rolesResponseHolder: any;
  currentUser: any;
  officectrl = new FormControl();
  getUserListModelCreate={
     search : '',
    pageSize: 0,
    pageIndex: 0,
    databaseID: 0,
    organizationID: 0
  }
  @Output() closeSidePanel = new EventEmitter();
  @Output() closeSidePanelAfterSave = new EventEmitter();

  clickEventsubscription: Subscription;
  offices: any;
  searchOffice: any=[];
  selectedOfficeArray: any=[];
  OfficeIDList: any=[];
  myOfficeID: any;
  dropdownSettings = {};
  dropdownList: any[] = [];
  selectedItems = [];
  rolesAsssign: any[] = [];
  spinner:boolean=false;
  @Output() getcloseCreateRole = new EventEmitter<boolean>()

  constructor(private formBuilder: FormBuilder,private customValidator: CustomvalidationService,
    private _userService: UserService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private _dataSharingService: DataSharingService,
    public _matDialog: MatDialog, private statusConst: StatusConstant,
    private loaderService: LoaderService, private toastr: ToastrService, private router: Router,
    private rolesService: RoleService, private paginationVm: PaginationViewModel) {
   
    this.createForm();
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

    this.getUserListModelCreate.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getUserListModelCreate.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }
 
  

  ngOnInit(): void {
    // this.clickEventsubscription = this._dataSharingService.getAddUserEvent().subscribe(() => {
    //   this.loaderService.hide();
    //   this.isActiveChecked=true;
    //   this.firstname.nativeElement.focus();
    //   this.paginationVm.pageIndex = 0;
    //   this.paginationVm.pageSize = 0;
    //   this.addPrefix();
    //   this.getRolesList();
    // });
    this.isActiveChecked=true;
    this.firstname.nativeElement.focus();   
    this.paginationVm.pageIndex = 0;
    this.paginationVm.pageSize = 0;
    this.addPrefix();
    this.getRolesList();
    this.getOrgOffices();
    this.dropdownSettings = {
      "singleSelection": false,
      "defaultOpen": false,
      "idField": "roleID",
      "textField": "roleName",
      "selectAllText": "Select All",
      "unSelectAllText": "UnSelect All",
      "enableCheckAll": true,
      "allowSearchFilter": true
    };
  }

  searchOfficeFun(val) {
    this.searchOffice=[];
      if(val != ''){
      this.searchOffice=this.offices.filter(m=>m.officeName.toLowerCase().includes(val.toLowerCase()));
    }else{
      this.searchOffice=this.offices;
    }
  }

  selectedOffice(o:any){
    if(o.officeID>0){
      var check =[];
      check = this.selectedOfficeArray.filter(m=>m.officeID==o.officeID)
        if(check.length>0){
          this.officectrl.reset();
          this.toastr.warning("Office allready selected", '', {
            timeOut: 3000,
          });
        }else{
          this.selectedOfficeArray.push(o);
          this.officectrl.reset();
        }
       }   
    if(this.selectedOfficeArray.length==0){
      this.userDetailform.markAsDirty();
    }
  }
  // selectedOffice(o:any){
  //   if(o.officeID>0){
  //     if(!this.selectedOfficeArray.find(m=>m.officeID==o.officeID))
  //      this.selectedOfficeArray.push(o);
  //      this.officectrl.reset();
  //   }
  //   if(this.selectedOfficeArray.length>0){
  //     this.userDetailform.markAsDirty();
  //   }
  // }

  
  removeSelectedOffice(o:any){
    if(o.officeID>0){
      this.selectedOfficeArray=this.selectedOfficeArray.filter(m=>m.officeID!=o.officeID);
    }
    if(this.selectedOfficeArray.length==0){
      this.userDetailform.markAsPristine();
    }
  }

  getOrgOffices() {
    this._userService.getOrgOffices({"OrganizationID":parseInt(sessionStorage.getItem('organizationID'))}).subscribe(response=>{     
      if (response) {
        this.rolesResponseHolder = response;
        if (this.rolesResponseHolder.status == this.statusConst.statusSuccess) {
          this.offices = this.rolesResponseHolder.data;  
          if(!this.selectedOfficeArray.find(m=>m.officeID==this.myOfficeID))
          this.selectedOfficeArray.push(this.offices.find(m=>m.officeID==this.myOfficeID));
        }
      }
    });
  }
 
  ngAfterViewChecked(): void {
    setTimeout(() => {
     // this.firstname.nativeElement.focus();
    }, 1);
  }

  // Create Register User Form
  createForm(): void {
    const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    // const alphaberregex: RegExp = /^[a-zA-Z ]+$/;
    this.userDetailform = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailregex)]],
      // username: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      password: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      confirmPassword: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneNumberregex)]],
      selectedroles: ['', Validators.required],
      isActive: true
    },
    {
      validator: this.customValidator.mustMatch('password', 'confirmPassword')
   });
  }

  // To allow only alphabets on FirstName and LastName
  // checkregex(): void {
  //   if (!this.userDetailform.controls['firstname'].value.match(/^[a-zA-Z ]+$/) && this.userDetailform.controls['firstname'].value !== '') {
  //     this.userDetailform.controls['firstname'].setValue("");
  //   } else if (!this.userDetailform.controls['lastname'].value.match(/^[a-zA-Z ]+$/) && this.userDetailform.controls['lastname'].value !== '') {
  //     this.userDetailform.controls['lastname'].setValue("");
  //   }
  //   this.titleAlert = 'Please enter only alphabets';
  // }

  allowAlphabetOnly(event) {
		const regexp = new RegExp('^[0-9!@#$&()\\-`.+,/\"]*$');
		const result = regexp.test(event.key);
		if (result) {
      this.titleAlert = 'Please enter only alphabets';
		  event.preventDefault();
		  return false;
		}
  }
    
  // To match password on confirm password input box
  matchPassword(): void {
    if (this.userDetailform.controls['password'].value !== this.userDetailform.controls['confirmPassword'].value) {
      this.userDetailform.controls['confirmPassword'].setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  // To check the existing user
  checkInUseEmail(): void {
    this.existingUser.Email = this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.userDetailform.controls['email'].value);
    this._userService.checkExistingUser(this.existingUser).subscribe(result => {
      if (result.data) {
        this.userDetailform.controls['email'].setErrors({ alreadyInUse: true });
        this.getErrorEmail();
      } else {
        return null;
      }
    });
  }

  get name() {
    return this.userDetailform.get('name') as FormControl;
  }

  // Get Errors for email field
  getErrorEmail() {
    return this.customValidator.getErrorEmail(this.userDetailform);
  }

  // Get Errors for password field
  getErrorPassword() {
    return this.customValidator.getErrorPassword(this.userDetailform);
  }

   // Get Errors for phoneNumber field
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.userDetailform);
  }


  // To Register New User
  async save(data) {
    this.spinner=true;
    this.userDetailform.markAsPristine();
    let userRoles = [];
    try {
      data.email = data.email.toLowerCase();
      this.userDetail.UserName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.email);
      this.userDetail.FirstName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.firstname);
      this.userDetail.LastName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.lastname);
      this.userDetail.Email = this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.email);
      this.userDetail.PasswordHash = this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.password);
      this.userDetail.PhoneNumber =  this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.phoneNumberExt + '' + data.phoneNumber);
      this.userDetail.orgaizationID = parseInt(sessionStorage.getItem('organizationID'));
      this.userDetail.databaseID = parseInt(sessionStorage.getItem('databaseId'));
      this.userDetail.CreatedBy = this.currentUser.UID;
     // this.userDetail.officeID=this.myOfficeID;
     this.userDetail.myOfficeID=this.myOfficeID;
      if(this.selectedOfficeArray){
      this.selectedOfficeArray.forEach(e => {
        if(!this.userDetail.offices.find(n=>n==e.officeID))
           this.userDetail.offices.push(e.officeID);
      });
    }
      data.selectedroles.forEach(element => {
        let id = element.roleID.toString();
        userRoles.push(id);
      });
              
      this.userDetail.UserRoles = userRoles;
      this.userDetail.TwoFactorEnabled = true;
      this.userDetail.isActive = (data.isActive !== true) ? false : data.isActive;
      this.loaderService.show();
      //return;
      const result = await this._userService.registerUser(this.userDetail).toPromise();
      this.createUserResponseHolder = result;
      this.loaderService.hide();
      this.spinner=false;
      if (this.createUserResponseHolder.status === this.statusConst.statusSuccess) {
        this.toastr.success("User Created successfully.", '', {
          timeOut: 3000,
        });
        let closePanel = true;
        this.closeSidePanelAfterSave.emit(closePanel);
       // this._dataSharingService.sendClickEvent();
        this.userDetailform.reset();        
      } else {
        this.spinner=false;
        this.loaderService.hide();
        this.toastr.warning("User already exist", '', {
         timeOut: 3000,
        });
        // this.toastr.error("Error with code:" + '' + this.createUserResponseHolder.status + '' + ", and with message:" + '' + this.createUserResponseHolder.message, '', {
        //   timeOut: 3000,
        // });
      }
    } catch (e) {
      this.spinner=false;
      Observable.throw(e);
    }
  }

 // To add the checkboxes in UserRole field
  equals(objOne, objTwo) {
    if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
      return objOne.id === objTwo.id;
    }
  }


// To close the dialog popup
  close(any) {    
    let closePanel = false;
    this.userDetailform.reset();
    this.closeSidePanel.emit(closePanel);    
    this.getcloseCreateRole.emit(any);
  }
  
  // show default extension in Phone Number extension field
  addPrefix() {
    this.phoneNumberExt = '+1';
  }

  getRolesList() {
    this.rolesService.getRoleList(this.getUserListModelCreate).subscribe(response=>{     
    if (response) {
      this.rolesResponseHolder = response;
      if (this.rolesResponseHolder.status == this.statusConst.statusSuccess) {
       // this.roles = this.rolesResponseHolder.data.roleModel;
        this.dropdownList = this.rolesResponseHolder.data.roleModel;
        this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));  
      
        if(this.rolesAsssign !=null){
        
          if(this.rolesAsssign?.length > 0){

           this.rolesAsssign = Object.values(
              this.rolesAsssign.reduce((a, c) => {
                a[c.roleID] = c;
                return a
              }, {}))

          //  var min=[];
          //  if(this.rolesAsssign.length==1){
          //   this.dropdownList=this.dropdownList.filter((m) => m.roleLevel >=this.rolesAsssign[0].roleLevel);
          //  }
          //  if(this.rolesAsssign.length>1){
          //   min = this.rolesAsssign.reduce((a, b)=>Math.min(a.roleLevel, b.roleLevel));
          //   this.dropdownList=this.dropdownList.filter((m) => m.roleLevel >=min || m.roleLevel==0);
          //  }     
           }
         }    
       }
      }
    });
  }


}

